<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Nápověda
            </div>
        </v-card-title>

        <v-card-text>
            <div v-if="isAdmin">
                <h2>
                    <v-icon large class="mr-5">person</v-icon>
                    Uživatelé
                </h2>
                <p>
                    Správa uživatelů dovoluje spravovat jednotlivé uživatele, kteří mají přístup do této administrace a
                    můžou pracovat s ostatními částmi administrace.
                </p>
                <p>
                    V detailu uživatele je možné mimo jiných polí i nastavit:
                </p>
                <ul>
                    <li>
                        <strong>Platnost</strong> - pokud se vyplní datum, bude pak možná kontrola vstupenek jen do
                        tohoto data včetně
                    </li>
                    <li>
                        <strong>Aktivní</strong> - určuje, jestli se uživatel může příhlásit do administrace
                    </li>
                    <li>
                        <strong>Administrátor</strong> - tento uživatel sám může zakládat další uživatele
                    </li>
                </ul>
            </div>

            <h2 class="mt-5">
                <v-icon large class="mr-5">event</v-icon>
                Události
            </h2>
            <p>
                Tato sekce slouží ke správě jednotlivých akcí
            </p>

            <h2 class="mt-5">
                <v-icon large class="mr-5">pie_chart</v-icon>
                Bloky
            </h2>
            <p>
                Každá událost má vstupenky rozdělené do jednotlivých bloků, které není možné ručně vytvořit,
                vytvoří se pří importu vstupenek.
            </p>
            <p>
                U akce je možné nastavit a aktivovat <strong>Hlášku při kontrole</strong>, které se při kontrole
                vstupenek zobrazí na display zařízení.
            </p>

            <h2 class="mt-5">
                <v-icon large class="mr-5">receipt</v-icon>
                Vstupenky
            </h2>
            <p>
                Přehled vstupenek zobrazuje všechny vstupenky, které je možné libovolně spravovat.
            </p>
            <p>
                Na této stránce je možné spustit import vstupenek v samostatném okně
            </p>

            <h2 class="mt-5">
                <v-icon large class="mr-5">devices</v-icon>
                Zařízení
            </h2>
            <p>
                Na této stránce je správa zařízení, které slouži je kontrole vstupenek.
                Zařízení je vždy vázané k jednomu učtu, ze kterého se pak načítají akce,
                které lze kontrolovat.
            </p>

            <h2 class="mt-5">
                <v-icon large class="mr-5">bar_chart</v-icon>
                Statistiky
            </h2>
            <p>
                Na této stránce je možné zobrazit časový průběh kontroly vstupenek v čase,
                rozdělený podle jednotlivých zařízení. Je možné filtrování podle akcí s nastavením
                časového rozsahu a rozlišení dat.
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        computed: {
            isAdmin() {
                return this.$store.state.user.logged && this.$store.state.user.logged.isSuperuser
            }
        }
    }
</script>

<style lang="scss">
    h2 {
        font-weight: normal;
        color: black;
        background-color: #eee;
        padding: 6px;
        margin-bottom: 10px;
    }
</style>
